import {
    createAsyncThunk,
    createSlice,
} from '@reduxjs/toolkit';

import {
    add,
    deleteRecord,
    fetch,
    fetchRecords,
    update,
} from '../services/RegistrationsService.ts';


import {
    deleteOneCase,
    fetchManyCase,
    fetchOneCase,
    saveOneCase,
    updateOneCase,
} from '../../../store/RecordsSliceCaseHelpers';
import {Registration} from '../types';

const entityKey = 'registrations';

interface RegistrationsState {
    byId: { [key: string]: Registration },
    ids: string[],
    totalCount: number,
    loading: boolean,
    error: string
}

const initialState = {
    byId: {},
    ids: [],
    totalCount: 0,
    loading: false,
    error: '',
} as RegistrationsState;


const normalizeRecord = (record: Registration) => {
    return Object.assign({}, record);
};

// generates pending, fulfilled and rejected
export const fetchRegistrations = createAsyncThunk(
    `${entityKey}/fetchRecords`,
    () => {

        return fetchRecords({})
            .then((response) => {
                if (response) {
                    return response.map((record: Registration) => {
                        return normalizeRecord(record);
                    });
                }
            });
    },
);

export const fetchRegistration = createAsyncThunk(
    `${entityKey}/fetch`,
    (id: string) => {
        return fetch(id)
            .then((response) => {
                if (typeof response !== 'undefined') {
                    return normalizeRecord(response);
                }
            });
    });

export const saveRegistration = createAsyncThunk(
    `${entityKey}/add`,
    (payload: Registration) => {
        return add(payload)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    });

export const updateRegistration = createAsyncThunk(
    `${entityKey}/update`,
    ({
         id,
         record,
     }: { id: string, record: Registration }) => {

        return update(id, record)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    },
);

export const deleteRegistration = createAsyncThunk(
    `${entityKey}/deleteRecord`,
    (id: string) => {
        return deleteRecord(id)
            .then(() => id);
    },
);


export const storeRegistration = createAsyncThunk(
    `${entityKey}/store`,
    (payload: Registration) => {
        return normalizeRecord(payload);
    },
);


const componentsSlice = createSlice({
                                        name: entityKey,
                                        initialState,
                                        reducers: {
                                            clearState: () => initialState,
                                        },
                                        extraReducers: (builder) => {
                                            // FETCH MANY
                                            fetchManyCase(builder, fetchRegistrations, entityKey);

                                            // FETCH ONE
                                            fetchOneCase(builder, fetchRegistration);

                                            // SAVE ONE
                                            saveOneCase(builder, saveRegistration);

                                            // UPDATE ONE
                                            updateOneCase(builder, updateRegistration);

                                            updateOneCase(builder, storeRegistration);

                                            // DELETE ONE
                                            deleteOneCase(builder, deleteRegistration);
                                        },
                                    });

export default componentsSlice.reducer;
